'use strict';
module.exports = function(data, encoding){
    return new Buffer(data, encoding);
};
module.exports.test = function(b){
    return Buffer.isBuffer(b);
};



//////////////////
// WEBPACK FOOTER
// ./~/_jszip@2.6.1@jszip/lib/nodeBuffer.js
// module id = 96
// module chunks = 0